<template>
    <div
        v-click-outside="{
            when: isOpenMoreOptions,
            callback: closeDropdown,
        }"
        class="more-options z-10"
    >
        <Btn
            variant="outlined"
            color="primary"
            color-on-active
            :active="!!filtersSelected"
            left-icon="filters"
            :right-icon="isOpenMoreOptions ? 'chevron-down' : 'chevron-up'"
            size="lg"
            class="button-size whitespace-nowrap"
            @click="toggleMoreOptions"
        >
            <template #default>
                {{ $t('filter.second_filter.more') }}
                <template v-if="filtersSelected">({{ filtersSelected }})</template>
            </template>

            <template
                v-if="filtersSelected"
                #right
            >
                <i
                    class="icon icon-close w-4 h-4"
                    @click.stop="removeFilters"
                ></i>
            </template>
        </Btn>

        <transition name="fade">
            <div
                v-if="isOpenMoreOptions"
                class="more-filters-container content absolute mt-2 ml-1 flex flex-col justify-between overflow-hidden rounded border bg-white p-4 sm:right-0 sm:mr-4 lg:right-auto lg:mr-0"
            >
                <div v-if="params.content === 'documents'">
                    <div class="mb-4 flex items-center">
                        <i class="icon icon-document mr-2"></i>
                        {{ $t('filter.document_type.h1') }}
                    </div>

                    <InputDocumentType
                        :model-value="params.document_type || []"
                        :totals="documentTypeTotals"
                        with-all
                        @input="onDocTypeChange"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import InputDocumentType from '@components/InputDocumentType';
import { mapGetters } from 'vuex';

export default {
    name: 'UniversityShowMoreOptions',
    i18nOptions: {
        namespaces: ['search'],
    },
    components: {
        InputDocumentType,
    },
    data() {
        return {
            isOpenMoreOptions: false,
        };
    },
    computed: {
        ...mapGetters({
            params: 'university/searchParams',
            screenSize: 'ui/screenSize',
            documentTypeTotals: 'university/documentTypeTotals',
        }),
        filtersSelected() {
            return this.params.document_type?.length || 0;
        },
    },
    methods: {
        onDocTypeChange(types) {
            this.$store.dispatch('university/applyParams', {
                document_type: types,
            });
        },
        toggleMoreOptions() {
            this.isOpenMoreOptions = !this.isOpenMoreOptions;
        },
        closeDropdown() {
            if (this.screenSize !== 'small') {
                this.isOpenMoreOptions = false;
            }
        },
        removeFilters() {
            this.$store.dispatch('university/applyParams', {
                document_type: [],
            });

            setTimeout(() => {
                this.isOpenMoreOptions = false;
            }, 50);
        },
    },
};
</script>

<style lang="scss" scoped>
.more-filters-container {
    width: 35rem;
}
</style>
